import React from "react";

export const inputCls = "w-full px-4 py-2.5 border border-gray-200 rounded-sm focus:outline-none focus:border-[#003B5C] bg-white";
export const labelCls = "block text-xs font-bold uppercase tracking-wider text-[#1E1E1E]/60 mb-2";

export const formatDate = (iso) => {
  if (!iso) return "";
  try { return new Date(iso + "T00:00:00").toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" }); }
  catch { return iso; }
};

const TONES = {
  gold: "bg-[#D4A437] text-white",
  navy: "bg-[#003B5C] text-white",
  gray: "bg-gray-200 text-[#1E1E1E]/70",
  amber: "bg-amber-100 text-amber-800 border border-amber-300",
};

export const Badge = ({ children, tone = "gold", testId }) => (
  <span data-testid={testId} className={`inline-flex items-center gap-1 text-[10px] font-bold uppercase tracking-wider px-1.5 py-0.5 rounded-sm ${TONES[tone] || TONES.gold}`}>{children}</span>
);
